import { useState } from "react";

// This hook is a small example of take the logic of a component for use in every place (in this case a form)
export const useForm = (initalValues) => {
	const [values, setValues] = useState(initalValues);

	// returns values and a function to handle the values
	return [values, (e) => setValues({ ...values, [e.target.name]: e.target.value })];
};
